import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Header from './components/Header';
import About from './components/services/services-images/About';
import Contact from './components/services/services-images/Contact';
import BlogSectionblog from './components/services/services-images/BlogSectionblog';
import Login from './components/Login';
import TrackYourOrder from './components/services/services-images/TrackYourOrder';
import Shilajit from './components/services/services-images/Shilajit';
import Combo from './components/services/services-images/Combo';
import Fitness from './components/services/services-images/Fitness';
import Faq from './components/Faq';
import Delivery from './components/services/services-images/Delivery';
import Mentalhealth from './components/services/services-images/Mentalhealth';
import Cart from './components/cart/Cart';
import Wishlist from './components/cart/Wishlist';
import { CartProvider } from './components/cart/CartContext';
function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/header" element={<Header />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogSectionblog" element={<BlogSectionblog />} />
          <Route path="/login" element={<Login />} />
          <Route path="/trackyourorder" element={<TrackYourOrder />} />
          <Route path="/shilajit" element={<Shilajit />} />
          <Route path="/combo" element={<Combo />} />
          <Route path="/faq" element={<Faq />} />
          <Route path='/delivery' element={<Delivery />} />
          <Route path='/fitness' element={<Fitness />} />
          <Route path='/mentalhealth' element={<Mentalhealth />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}
export default App;


// https://www.thehimalayanorganics.in/pages/about-us-1
// https://upakarma.com/about
// https://rasayanam.in/blogs/news
// https://ayuvya.com/




